import { SxProps } from '@mui/material';

export const headerMobileDrawerContainerSX: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	height: '100%',
	width: 320,
};

export const headerMobileDrawerSX: SxProps = {
	flex: 1,
	py: '10px',
	px: '20px',
};

export const headerMobileLinkBaseSX: SxProps = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-start',
	fontSize: '15px',
	color: 'text.primary',
	width: '100%',
	gap: '0.5rem',
	'&:hover': {
		textDecoration: 'none',
		color: 'primary.main',
	},
};

export const headerMobileLinkLightSX: SxProps = {
	paddingY: '1rem',
	cursor: 'pointer',
};

export const headerMobileLinkBoldSX: SxProps = {
	fontWeight: 'bold',
	paddingY: '0.2rem',
};

export const headerMobileSupportLinksContainerSX: SxProps = {
	marginTop: 1.5,
};

export const headerMobileOpeningHoursSX: SxProps = {
	marginTop: 1.5,
	fontSize: '15px',
};

export const headerMobileBackContainerSX: SxProps = {
	display: 'flex',
	justifyContent: 'flex-end',
	width: '100%',
};

export const headerMobileBackIconSX: SxProps = {
	fontSize: '1.7rem',
	color: 'black',
};

export const headerMobileBreadcrumbMenuItemLinkSX: SxProps = {
	width: '100%',
	display: 'flex',
	alignItems: 'center',
	py: 1,
	justifyContent: 'space-between',
};

export const headerMobileBreadcrumbMenuIconSX: SxProps = {
	fontSize: '1rem',
};

export const headerMobileBreadcrumbTypographyMainSX: SxProps = {
	fontWeight: '900',
	color: 'black',
	textTransform: 'uppercase',
	fontSize: '16px',
};

export const headerMobileBreadcrumbsSX: SxProps = {
	mb: 2,
};

export const headerMobileBreadcrumbBackContainerSX: SxProps = {
	mb: 5,
};

export const headerSearchMobileDrawerContainerSX: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	height: '100%',
	width: '100%',
};

export const headerMobileCloseSearchIconSX: SxProps = {
	fontSize: '1.7rem',
	color: 'black',
	marginTop: '21px',
};
